<template>
  <div class="orderModifyAddress" >
    <div class="pageContent">
      <XR-head titleText="修改收货地址" :rightShow="false" ref="headObj"></XR-head>

      <router-link to="/usercenter/address?redirecturl=/usercenter/orderModifyAddress">
        <div class="receive-address">          
          <div class="mapIcon">
            <i class="fa fa-location"></i>
          </div>
          <div class="address-info" :style="{width:addressInfoWidth+'px'}">
            <div class="contract">
              <span class="name">{{receiveAddress.Receiver}}</span>
              <span class="mobile">{{receiveAddress.Phone}}</span>
            </div>
            <div class="address-content">
              <span class="text">{{receiveAddress.DetailAddress}}</span>
            </div>
          </div>
          <div class="goIcon">
            <i class="fa fa-angle-right"></i>
          </div>
        </div>
      </router-link>

      <div class="bottom-bar">
        <mu-row >
          <mu-col width="100" tablet="100" desktop="100">
            <mu-raised-button label="确 定" class="gobuy" primary fullWidth @click="submit"></mu-raised-button>
          </mu-col>
        </mu-row>
      </div>
    </div>
    <XR-toast @onClose="submitSuccess" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import cart from '../../util/cart'
export default {
  data () {
    return {
      addressInfoWidth: (parseInt(document.documentElement.clientWidth)-70) ,  
      deliveryPopup: false,
      receiveAddress :{},
      ungetInfo:{
        addrId:0,
        orderNo: this.$route.query.orderNo
      }
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()
    this.getDefaultAddress()
  },
  methods: {
    getDefaultAddress(){
      var ths = this
      ths.$post(
        "/Shop/UserServer/GetDefaultReceiveAddress"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.$refs.XRtoast.hide()
          ths.receiveAddress = res.Data
          ths.ungetInfo.addrId = res.Data.Id
          ths.loaded = false
        }
      });
    },
    submit(){
      if(this.ungetInfo.addrId ==0){
        this.$refs.XRtoast.failed("请选择收货地址", true)
        return
      }
      var ths = this
      ths.$post(
        "/Shop/RetailServer/ModifyReceiveAddress",
        JSON.stringify(this.ungetInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    submitSuccess(){
      this.$router.push('/usercenter/orderdetail?orderNo='+this.ungetInfo.orderNo)
    }
  }
}
</script>
<style>
body .orderModifyAddress{
  background: #F0F2F5;
  bottom: unset;
}
.pageContent{
  padding-bottom: 56px;
}

.orderModifyAddress .goIcon{
  width: 20px;
  float: right;
  text-align: right;
}

.orderModifyAddress .mapIcon{
  float: left;
  width: 30px;
  line-height: 64px;
}

.orderModifyAddress .receive-address{
  background: white;
  color:black;
  padding: 10px;
  overflow: hidden;
}
.orderModifyAddress .receive-address .address-info{
  float: left;
}
.orderModifyAddress .receive-address .address-info .name{
  font-size:16px;
  font-weight: 700;
  padding-right: 15px;
}
.orderModifyAddress .receive-address .address-info .mobile{
  font-size:16px;
  font-weight: 700;
}
.orderModifyAddress .receive-address .address-info .address-content{
  font-size:12px;
  line-height: 18px;
  color:#999;
}
.orderModifyAddress .receive-address .address-info .address-content .fa{
  width: 20px;
}
.orderModifyAddress .receive-address .goIcon{
  line-height: 64px;
}

.orderModifyAddress .choose-info{
  overflow: hidden;
  padding:10px;
  background: white;
  margin-top: 10px;
}
.orderModifyAddress .choose-info .info{
  font-size: 12px;
  float: left;
  line-height: 24px;
}
.orderModifyAddress .choose-info .info.center{
  float: right;
}
.orderModifyAddress .choose-info .info.left {
  width: 150px;
}
.orderModifyAddress .choose-info .info.left .title{
  font-size: 14px;
  font-weight: 700;
}
.orderModifyAddress .choose-info .info .choose-row{
  line-height: 24px;
}
.orderModifyAddress .choose-info .info.center .choose-row{
  text-align: right;
}
.orderModifyAddress .choose-info.integral .info.left .choose-row.balance{
  color:red;
}
.orderModifyAddress .choose-info .goIcon{
  line-height: 48px;
}

.orderModifyAddress .remark{
  background: white;
  margin-top: 10px;
  padding:10px 10px 0;
}

.orderModifyAddress .price-info{
  background: white;
  margin-top: 10px;
  padding:10px 10px 40px;
}
.orderModifyAddress .price-info .row{
  background: white;
  overflow: hidden;
  line-height: 32px;
}
.orderModifyAddress .price-info .row .title{
  font-size: 14px;
  font-weight: 700;
}
.orderModifyAddress .price-info .row .price{
  color:Red;
  font-weight: 700;
}



.orderModifyAddress .pro-list{
  margin-top: 10px;
  background: white;
  overflow: hidden;
}
.orderModifyAddress .pro-list .pro-item{
  padding: 16px 0;
  overflow: hidden;
}
.orderModifyAddress .pro-list .pro-item .pro-img{
  width: 80px;
  float: left;
}
.orderModifyAddress .pro-list .pro-item .pro-img img{
  width: 100%;
  display: block;
  border-radius: 4px;
  margin: 0 20px;
}
.orderModifyAddress .pro-list .pro-item .pro-info{
  float: right;
  padding-right: 10px;
}
.orderModifyAddress .pro-list .pro-item .pro-info .pro-name{
  font-size: 12px;
  line-height: 16px;
  height: 32px;
  padding-bottom: 4px;
  overflow: hidden;
}
.orderModifyAddress .pro-list .pro-item .pro-info .pro-attr{
  font-size: 12px;
  line-height: 16px;
  height: 30px;
  color:#999;
}
.orderModifyAddress .pro-list .pro-item .pro-info .pro-num{
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  color:#999;
}
.orderModifyAddress .pro-list .pro-item .pro-info .pro-num .pro-price{
  font-size: 16px;
  line-height: 16px;
  float: left;
  color:red;
}
.orderModifyAddress .pro-list .pro-item .pro-info .pro-num .count{
  font-size: 12px;
  line-height: 16px;
  color:#999;
  float: right;
}




.orderModifyAddress .bottom-bar{  
  margin-top: 50px;
  height: 56px;
  border-top:1px solid #eee;
  padding: 0 10%;
}
.orderModifyAddress .gobuy{
  width: 100%;
  line-height: 50px;
  height: 50px;
  text-align: center;
}

.orderModifyAddress-popupLayer {
  width: 100%;
  min-height: 120px;
}
.orderModifyAddress-popupLayer .deliveryChoose {
  padding: 0 10px;
}
.orderModifyAddress-popupLayer .delvieryChooseBtn{
  margin: 40px 0 0;
  height: 50px; 
}

.orderModifyAddress-popupLayer .shippingBtn.select{
  background: red;
  color:white;
}

</style>



// WEBPACK FOOTER //
// src/pages/usercenter/ordermodifyaddress.vue